import { Icon } from 'semantic-ui-react';

const NoResultsMessage = () => {
  return (
    <div className="noResultsMessage flexCentered">
      <Icon
        name="exclamation circle"
        style={{
          marginBottom: '0.5em',
          fontSize: '2em',
        }}
      />
      No Results
      <br />
      Check back later for our first result!
      <style jsx>
        {`
          :global(.noResultsMessage) {
            color: gray;
            font-size: 1.2em;
            text-align: center;
            padding-bottom: 3em;
          }

          :global(.noResultsMessage > *) {
            margin: 10px;
          }
        `}
      </style>
    </div>
  );
};

export default NoResultsMessage;
